var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showDashboard
        ? _c(
            "v-container",
            { attrs: { "grid-list-xl": "", fluid: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs10: "", "offset-xs1": "" } },
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-xl": "", fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "" } }, [
                                _c("h1", [
                                  _vm._v("Update Daily Company Target")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "xs10",
                                    model: {
                                      value: _vm.setting.companyTarget,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.setting,
                                          "companyTarget",
                                          $$v
                                        )
                                      },
                                      expression: "setting.companyTarget"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ml-0",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateCompanyTarget()
                                        }
                                      }
                                    },
                                    [_vm._v("update")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs12: "" } }, [
                                _c("h1", [_vm._v("Update Monthly Target")])
                              ]),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs12: "" } }, [
                                _c("table", { attrs: { width: "100%" } }, [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-xs-left",
                                          attrs: { width: "35%" }
                                        },
                                        [_vm._v("Name")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-xs-left",
                                          attrs: { width: "25%" }
                                        },
                                        [_vm._v("Email")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-xs-center",
                                          attrs: { width: "25%" }
                                        },
                                        [_vm._v("Monthly Target")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-xs-center",
                                          attrs: { width: "15%" }
                                        },
                                        [_vm._v("Action")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.salesUsers, function(
                                      user,
                                      index
                                    ) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(user.firstName))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [_vm._v(_vm._s(user.email))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-left" },
                                          [
                                            _c("v-text-field", {
                                              staticClass: "xs10",
                                              model: {
                                                value: user.position.target,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    user.position,
                                                    "target",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "user.position.target"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { small: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateTarget(
                                                      user
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("update")]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-snackbar",
                                {
                                  attrs: { dark: "", top: "", timeout: 3000 },
                                  model: {
                                    value: _vm.snackbar,
                                    callback: function($$v) {
                                      _vm.snackbar = $$v
                                    },
                                    expression: "snackbar"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.popupText) +
                                      "\n              "
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { dark: "", flat: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.snackbar = false
                                        }
                                      }
                                    },
                                    [_vm._v("Close")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-container",
            { attrs: { "grid-list-xl": "", fluid: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        xs10: "",
                        "offset-xs1": "",
                        "text-xs-center": ""
                      }
                    },
                    [_c("h1", [_vm._v("Nothing to show")])]
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42baf92c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42baf92c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/salesUsers.vue
// module id = null
// module chunks = 